module.exports = __webpack_public_path__ + "media/images/icons/material/chevron-up-abe67425b133131bd85d1e934b543c67.svg";